import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import WhyHost from './WhyHost';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }) {
  const title = intl?.formatMessage(messages.whyHost);
  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    component: <AdminLayout><WhyHost title={title} /></AdminLayout>,
  };
}
